<template>
  <div @click.stop ="clickBtn($event)" class="xBtn hove ub-box ub-ver-h z-relative z-overflow-hidden z-select-none z-curPonit z-textAlign-center" :style="{background:isActive===true ? btnStyle['active'] : currColor ,padding:defaultStyle['padding'],margin:defaultStyle['margin'],width:defaultStyle['width'],height:defaultStyle['height'],lineHeight:defaultStyle['lineHeight']}" :class="{'cancelc': type === 'cancel','confirm': type === 'confirm','back': type === 'back','is-disabled':disabled === true}" ref="border">
    <slot name="before"></slot>
    <span v-if="type != 'cancel'" :class="{'ub-ver-h':isActive === void 0}" class="ub-box ub-ver-v z-color-fff" :style="{color: menuIsActive===true ? btnStyle['menuIsActive']: '#f2f2f2', fontSize: fontSize? fontSize : '14px' }" ref="fonts">{{font}}</span>
    <span v-if="type === 'cancel'" :class="{'ub-ver-h':isActive === void 0}" class="ub-box ub-ver-v" :style="{fontSize: fontSize? fontSize : '14px' }" style="color:#6d6d6d;" ref="fonts">{{font}}</span>
    <slot name="after"></slot>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        btnStyle:{
          transparent:'transparent',
          white:'#fff',
          kefu:'#4cb9f1',
          tousu:'#fff',
          orange:'#ff8800',
          buy:'#04baf0',
          add:'#2DBACE',
          cancel:'',
          delete:'#f67358',
          update:'#ffa63b',
          look:'#2ebace',
          active:'#000',
          menuIsActive: '#2ebace',
          shelve: '#a287ea',
          yanzheng: '#f90101',
          change:'#ff4400',
          confirm:'#2082dd',
          search:'#f7f7f7',
          back:'#f7f7f7',
          addjieru:'#0A99F3',
        },
        currColor:'',
        defaultStyle:{padding:'.3rem 1.5rem'},
        fontSize: '',
      }
    },
    props:{
      font: {
        type: String,
        default: '保存'
      },
      type: {
        type: String,
        default: 'look'
      },
      isActive: {},
      menuIsActive: {
        default: false
      },
      optionStyle: {
        type: Object,
        default: ()=>{}
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    mounted(){
      this.currColor = this.btnStyle[this.type]
      this.defaultStyle = Object.assign({},this.defaultStyle,this.optionStyle)
      if(this.defaultStyle.hasOwnProperty('background')) {
        this.currColor = this.optionStyle['background']
      }
      if(this.defaultStyle.hasOwnProperty('fontSize')) {
        this.fontSize = this.optionStyle['fontSize']
      }
      if(this.defaultStyle.hasOwnProperty('margin')) {
        this.margin = this.optionStyle['margin']
      }
      if(this.defaultStyle.hasOwnProperty('width')) {
        this.width = this.optionStyle['width']
      }
      if(this.defaultStyle.hasOwnProperty('height')) {
        this.height = this.optionStyle['height']
      }
      if(this.defaultStyle.hasOwnProperty('lineHeight')) {
        this.lineHeight = this.optionStyle['lineHeight']
      }
      if( this.type === 'cancel') {
        this.$refs.fonts.style.color = '#000'
      }
      if(this.type === 'tousu') {
        this.$refs.fonts.style.color = '#04baf0'
      }
      if(this.type === 'search' || this.type === 'back') {
        this.$refs.fonts.style.color = '#333'
      }
      if(this.type === 'kefu' || this.type === 'tousu') {
        this.$refs.border.style.padding = '.4rem 3rem'
      }

    },
    methods:{
      clickBtn(evt){
        this.$emit('XbuttonService',this.type)
      },
    }
  }
</script>

<style scoped>
  .xBtn { border-radius: 2px;}
  .xBtn:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;transition:background-color ease-in .2s;}
  .xBtn:hover:after{background-color:rgba(255,255,255,.2);}
  .xBtn.cancelc { background-color: #fff; }
  .xBtn.cancelc:hover { border: 1px solid #a0a0a0;background-color: #e6e6e6; }
  .cancelc { border: 1px solid #cfcfcf; }
  .confirm { border: 1px solid #2082dd; }
  .back { border: 1px solid #dcdcdc; }
</style>



// WEBPACK FOOTER //
// src/components/commons/Xbutton.vue